export enum CourtRecordingStatus {
  AWAITING_UPLOAD = 'awaitingUpload',
  QUEUED = 'queued',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export type CourtRecordingStageDto = {
  stage: string;
  startedAt: string;
  completedAt?: string;
  error?: string;
};

export type CourtRecordingDto = {
  id: string;
  /**
   * @deprecated Tokenless, Azure-coupled, and removed in the storage epic's
   * Phase 3. Never put it in a player — playback goes through
   * `GET /court-recordings/:id/video-url` (admin) or
   * `.../player-video-url` (player), each of which mints a fresh short-lived
   * signed URL. To ask "is there a video?", read {@link hasVideo}.
   *
   * Optional since P0.1: the column is nullable now that recordings identify
   * their blobs by key.
   */
  videoUrl?: string;
  /** @deprecated Same contract as {@link videoUrl}. */
  analysisBlobUrl?: string;
  /**
   * Whether this recording has a video blob — the presence flag to gate a
   * player on, so no client has to read {@link videoUrl} to find out.
   *
   * Exactly as truthy as `Boolean(videoUrl)` was, deliberately and no better:
   * it is `true` for an `awaitingUpload` recording whose blob does not exist
   * yet, because the row carries a placeholder from seed time. Check `status`
   * as well if that matters to your surface.
   */
  hasVideo: boolean;
  status: CourtRecordingStatus;
  errorMessage?: string;
  durationSeconds?: number;
  fileSizeBytes?: number;
  stages?: CourtRecordingStageDto[];
  currentStage?: string;
  courtId: number;
  courtName: string;
  gameId?: number;
  startedAt?: string;
  endedAt?: string;
  /**
   * When `GET agent/pending-uploads` FIRST offered this recording to a box.
   * Unset = never offered. The recovery cron's 6 h `agent_timeout` clock runs
   * from here, not from `endedAt`, so an outage at the venue does not fail a
   * recording the box still holds.
   */
  lastOfferedAt?: string;
  failureReason?: string;
  organizationId: string;
  createdBy?: {
    id: string;
    email: string;
  };
  processingStartedAt?: string;
  completedAt?: string;
  /**
   * When the retention sweep deleted this recording's video (per-org
   * retention, `Organization.recordingRetentionDays`). Set ⇒ `hasVideo` is
   * false, status is still COMPLETED, and both `video-url` routes answer 410.
   */
  expiredAt?: string;
  lastTriggerAttemptAt?: string;
  lastTriggerError?: string;
  createdAt: string;
  updatedAt: string;
};

export class CreateCourtRecordingInputDto {
  courtId: number;

  gameId?: number;
}

export type CourtRecordingWebhookStatus = CourtRecordingStatus | 'progress';

export class CourtRecordingWebhookInputDto {
  recordingId: string;

  status: CourtRecordingWebhookStatus;

  currentStage?: string;

  analysisBlobUrl?: string;

  errorMessage?: string;

  secret: string;
}
